<template>
    <div>
        <div v-if="events.length > 0">
            <b-list-group class="list-group-accent" v-for="event in events" :key="event.id">
                <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small" v-if="event.type==='title'">
                {{ event.title }}
                </b-list-group-item>
                <b-list-group-item href="#" :class="[ event.class ]" class="list-group-item-divider" v-else-if="event.invited.length = 1">
                <div class="avatar float-right">
                    <img class="img-avatar" :src="event.invited[0].avatar" :alt="event.invited[0].email">
                </div>
                <div>{{ event.title }}
                </div>
                <small class="text-muted mr-3">
                    <i class="icon-calendar"></i>&nbsp;&nbsp;{{ event.time }}
                </small>
                <small class="text-muted">
                    <i class="icon-location-pin"></i>&nbsp;&nbsp;{{ event.location }}
                </small>
                </b-list-group-item>
                <b-list-group-item href="#" class="list-group-item-accent-danger list-group-item-divider" v-else>
                <div>{{ event.title }}
                </div>
                <small class="text-muted mr-3"><i class="icon-calendar"></i>&nbsp;&nbsp;{{ event.time }}</small>
                <small class="text-muted"><i class="icon-home"></i>&nbsp;&nbsp;{{ event.location }}</small>
                <div class="avatars-stack mt-2" v-if="event.invited.length > 1">
                    <div class="avatar avatar-xs" v-for="invite in event.invited" :key="invite.id">
                    <img class="img-avatar" :src="invite.avatar" :alt="invite.email">
                    </div>
                </div>
                </b-list-group-item>
            </b-list-group>
        </div>
        <div v-else>
            <b-list-group class="list-group-accent">
                <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
                Hoje
                </b-list-group-item>                
                <b-list-group-item href="#" class="list-group-item-accent-danger list-group-item-divider">
                    <small class="text-muted">
                        Nenhum evento para os próximos dias
                    </small>
                </b-list-group-item>
            </b-list-group>
        </div>
    </div>
</template>

<script>
export default {
  name: "AsideEventComponent",
    data: function() {
        return {
            events: [
                /*
                {
                "id" : 1,
                "type" : "title",
                "title" : "Hoje"
                },
                {
                "id" : 2,
                "type" : "event",
                "color" : "success",
                "title" : "Reunião com Alexandre",
                "date" : "2022-04-08",
                "time" : "1-3pm",
                "icon" : "icon-location-pin",
                "location" : "A6i",
                "class" : "list-group-item-accent-danger",
                "invited" : [
                    {
                    "id" : 342,
                    "avatar" : "img/avatars/3.jpg",
                    "name" : "Adriana",
                    "email" : "adriana@a6i.com.br",
                    "username" : "adriana" 
                    }
                ]
                },
                
                {
                "type" : "title",
                "title" : "Amanhã"
                },
                {
                "type" : "event",
                "color" : "success",
                "title" : "Reunião com André",
                "date" : "2022-04-08",
                "time" : "2-5pm",
                "icon" : "icon-location-pin",
                "location" : "Skype",
                "class" : "list-group-item-accent-warning",
                "invited" : [
                    {
                    "avatar" : "img/avatars/2.jpg",
                    "name" : "Adriana",
                    "email" : "adriana@a6i.com.br",
                    "username" : "adriana" 
                    },
                    {
                    "avatar" : "img/avatars/3.jpg",
                    "name" : "Adriana",
                    "email" : "adriana@a6i.com.br",
                    "username" : "adriana" 
                    }
                ]
                },
                {
                "type" : "event",
                "color" : "success",
                "title" : "Reunião com André",
                "date" : "2022-04-08",
                "time" : "2-5pm",
                "icon" : "icon-location-pin",
                "location" : "Skype",
                "class" : "list-group-item-accent-primary",
                "invited" : [
                    {
                    "avatar" : "img/avatars/2.jpg",
                    "name" : "Adriana",
                    "email" : "adriana@a6i.com.br",
                    "username" : "adriana" 
                    },
                    
                ]
                },
                {
                "type" : "event",
                "color" : "success",
                "title" : "Reunião com André",
                "date" : "2022-04-08",
                "time" : "2-5pm",
                "icon" : "icon-location-pin",
                "location" : "Skype",
                "class" : "list-group-item-accent-success",
                "invited" : [
                    {
                    "avatar" : "img/avatars/5.jpg",
                    "name" : "Adriana",
                    "email" : "adriana@a6i.com.br",
                    "username" : "adriana" 
                    },
                    {
                    "avatar" : "img/avatars/1.jpg",
                    "name" : "Adriana",
                    "email" : "adriana@a6i.com.br",
                    "username" : "adriana" 
                    }
                ]
                
                }
                */
            ]
            
        }
    }
}
</script>
